import { Amplify } from "aws-amplify";

const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_AWS_USER_POOL_ID || "",
      userPoolClientId: import.meta.env.VITE_AWS_USER_POOL_CLIENT_ID || "",
      region: import.meta.env.VITE_AWS_REGION || "us-east-1",
      loginWith: {
        email: true,
        username: false,
        phone: false,
      },
    },
  },
};

// Only configure Amplify if credentials are provided
if (amplifyConfig.Auth.Cognito.userPoolId && amplifyConfig.Auth.Cognito.userPoolClientId) {
  Amplify.configure(amplifyConfig);
}

export default amplifyConfig;
